import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const geojsonExportUrl = contractId => `${environment.apiUrl}/geojson/export/${contractId}`;
const geojsonExportContractsUrl = contractIds => `${environment.apiUrl}/geojson/export/contracts/${contractIds}`;

// const geojsonFcdUrl = (fcdProviderId, locationType) => `${environment.apiUrl}/geojson/fcd/${fcdProviderId}/${locationType}`;

@Injectable()
export class GeojsonService {
  constructor(private readonly httpService: HttpService) {}

  downloadGeojsonContract(contractId: number, locationType: string): Observable<any> {
    const url = `${geojsonExportUrl(contractId)}?locationType=${locationType}`;
    return this.httpService.post(url, null);
  }

  downloadGeojsonContracts(contractIds: number[], locationType: string): Observable<any> {
    const url = `${geojsonExportContractsUrl(contractIds)}?locationType=${locationType}`;
    return this.httpService.post(url, null);
  }

  // TODO: Add to back-end??
  // downloadGeojsonFcdProvider(fcdProviderId: string, locationType: string): Observable<any> {
  //     return this.httpService.getFile(geojsonFcdUrl(fcdProviderId, locationType));
  // }
}



// WEBPACK FOOTER //
// ./src/app/services/geojson.service.ts